import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import Helmet from 'react-helmet'

import divider2 from '../../img/bg/divider2.jpg';
import startupinspector_img from '../../img/startupinspector/startupinspector.jpg';
import kassenlotse_img from '../../img/kassenlotse/kassenlotse.jpg';

class HeaderComplete extends React.Component {
  render() {
    // console.log("props", this.props)
    // const pageLinks = []
    // const site = get(this, 'props.data.site.siteMetadata')
    return (
		<div id="headerwrap" name="home" style={{backgroundImage: 'url(' + divider2 + ')' }} >
			<header className="clearfix">
				<h1><span className="icon icon-w"></span></h1>
				<p>Christian Wolter</p>
			</header>
		</div>
		)
	}
}

 class Footer extends React.Component {
	 constructor() {
     super();
     	this.state = {
         intervalId: 0
     };
   }

   scrollStep() {
     if (window.pageYOffset === 0) {
         clearInterval(this.state.intervalId);
     }
     window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
   }

   scrollToTop() {
     let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
     this.setState({ intervalId: intervalId });
   }
   render () {
		 return <div>
							 <div id="footerwrap">
										<div className="container">
												<h4><small>created by Christian Wolter - copyright 2019 - <Link to='/imprint' onClick={ () => { this.scrollToTop(); }}>imprint | disclaimer</Link> -  <Link to='/privacy' onClick={ () => { this.scrollToTop(); }}>privacy</Link></small></h4>
										</div>
							 </div>
						 </div>;
 		}
  }

class ScrollButton extends React.Component {
  constructor() {
    super();
    	this.state = {
        intervalId: 0
    };
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  render () {
      return <button title='Back to top' className='scroll'
               onClick={ () => { this.scrollToTop(); }}>
                <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
              </button>;
   }
}

class Projects extends React.Component {
  render() {
    const pathPrefix =
      process.env.NODE_ENV === 'development' ? '' : __PATH_PREFIX__
    return (
			<div>
				<HeaderComplete />
				<div className="container" id="bachelorthesis" name="bachelorthesis">
							<br/>
							<br/>
							<div className="row">
								<h2 className="centered">Projects</h2>
								<hr/>
								<br/>

								<div className="col-md-offset-2 col-md-8">
									<p>
										<small>Steve Jobs:</small><br/>
										“Sometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations.”
									</p>
								</div>

								<div className="col-md-2">
								</div>
							</div>

							<div className="row">
								<hr/>
								<br/>
								<div className="col-md-offset-2 col-md-8">
									<h3>
										<a href="http://startup-inspector.de" target="_blank"><strong>startup</strong>INSPECTOR</a>
									</h3>

									<div className="row">
										<div className="col-md-8 col-sm-8 col-xs-12">
											<p>The startupINSPECTOR is the result of my masters thesis and coded by myself.</p>
											<p>The tool will help companies to improve their innovation management tasks by adding informations about start ups to their knowledge protfolio.
												The startupINSPECTOR combines trends and technologies with start ups in order to find new inspirations, technologies or investment oportunities.</p>
											<p>The range of functions and content are constantly being expanded and optimized. Right now it is possible to browse start ups and to discover related start ups, connected technologies and trends.</p>
										</div>
										<div className="col-md-4 col-sm-4 col-xs-12">
											<img src={startupinspector_img} alt="Startup Inspector" className="img-responsive img-rounded" />
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<p>The version 1.0 is available as a demo at <a href="http://startup-inspector.de" target="_blank">startup-inspector.de</a>.</p>
										</div>
									</div>
								</div>
							</div>

							<div className="row">
								<hr/>
								<br/>
								<div className="col-md-offset-2 col-md-8">
									<h3>
                    <a href="http://kassenlotse.christian-wolter.com" target="_blank">Kassenlotse</a>
									</h3>

									<div className="row">
										<div className="col-md-8 col-sm-8 col-xs-12">
											<p>This was a portal to compare german health insurances plans, based on "IGEL Leistungen".</p>
											<p>The tool was the result of my bacherlor thesis and coded by myself. After two years I stopped the project but you can still take a look at <a href="http://kassenlotse.christian-wolter.com" target="_blank">kassenlotse.christian-wolter.com</a>.
                      </p>
                      <p>
                        User: testuser<br/>
                        PW: vuirMQ$74PYgmisivQExZzy
                      </p>
                      <p>Please note that the data is not up to date.</p>
										</div>
										<div className="col-md-4 col-sm-4 col-xs-12">
											<img src={kassenlotse_img} alt="Kassenlotse" className="img-responsive img-rounded" />
										</div>
									</div>
								</div>
							</div>

						</div>
						<ScrollButton scrollStepInPx="50" delayInMs="16.66" />
						<Footer />
			</div>
    )
  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/pages/projects/index.jsx